import firebase from 'firebase/app';
import 'firebase/remote-config';

export default function pickupSurveyIsEnabled() {
  const remoteConfig = firebase.remoteConfig();
  return remoteConfig.getValue('enable_pickup_survey').asBoolean();
}
